/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
import { notification } from 'antd'
import ApiEndPoints from 'utils'
import apiClient from '..'

export const getAllCategoryOfReimbursableExpenses = async (globalTypeCategory) => {
  try {
    const response = await apiClient.get(`${ApiEndPoints.GLOBAL_TYPE}`, {
      params: {
        globalTypeCategory,
      },
    })
    if (response?.data) {
      return response.data
    }
    throw new Error('failed. No response received.')
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'An unexpected error occurred.'
    notification.error({
      message: 'Error',
      description: errorMessage,
    })
    throw error
  }
}

export const createReimbursment = async (data) => {
  try {
    const response = await apiClient.post(ApiEndPoints.REIMBURSMENT, data)
    if (response?.data) {
      return response.data
    }
    throw new Error('not created.')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const getReimbursment = async (
  skip = 0,
  limit,
  status,
  expenseFor,
  totalPrice,
  rangeDate,
  comparisonWithtotalPrice,
) => {
  try {
    console.log('status---------->0, ', status)
    const response = await apiClient.get(ApiEndPoints.REIMBURSMENT, {
      params: {
        skip,
        limit,
        status,
        expenseFor,
        totalPrice,
        rangeDate,
        comparisonWithtotalPrice,
      },
    })
    if (response?.data) {
      return response.data
    }
    throw new Error('Fetch failed. No response data received.')
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'An unexpected error occurred.'
    notification.error({
      message: 'Error',
      description: errorMessage,
    })
    throw error
  }
}

export const updateReimbursementApprove = async (data, id) => {
  try {
    const response = await apiClient.patch(`${ApiEndPoints.REIMBURSMENT}/${id}/approve`, data)
    if (response?.data) {
      return response.data
    }
    throw new Error('not updated.')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateReimbursementDelete = async (data, id) => {
  try {
    const response = await apiClient.delete(`${ApiEndPoints.REIMBURSMENT}/${id}`, data)
    if (response?.data) {
      return response.data
    }
    throw new Error('not updated.')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateReimbursementReject = async (data, id) => {
  try {
    const response = await apiClient.patch(`${ApiEndPoints.REIMBURSMENT}/${id}/reject`, data)
    if (response?.data) {
      return response.data
    }
    throw new Error('not updated.')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const updateReimbursement = async (data, id) => {
  try {
    const response = await apiClient.patch(`${ApiEndPoints.REIMBURSMENT}/${id}//approve`, data)
    if (response?.data) {
      return response.data
    }
    throw new Error('not updated.')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const uploadReimbursement = async (formData) => {
  try {
    const response = await apiClient.post(`${ApiEndPoints.REIMBURSMENT_DOC}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    if (response?.data) {
      return response.data
    }
    throw new Error('Upload failed. No response data received.')
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'An unexpected error occurred.'
    notification.error({
      message: 'Error',
      description: errorMessage,
    })
    throw error
  }
}
export const updateReimbursementDoc = async (formData) => {
  try {
    const response = await apiClient.patch(`${ApiEndPoints.REIMBURSMENT_DOC}/update`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    if (response?.data) {
      return response.data
    }
    throw new Error('Upload failed. No response data received.')
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'An unexpected error occurred.'
    notification.error({
      message: 'Error',
      description: errorMessage,
    })
    throw error
  }
}
export const getReimbursementDocByReimbursementId = async (id, page = 1, pageSize = 10) => {
  try {
    const response = await apiClient.get(`${ApiEndPoints.REIMBURSMENT_DOC}/${id}`, {
      params: { page, limit: pageSize },
    })
    if (response?.data) {
      return response.data
    }
    throw new Error('failed. No response received.')
  } catch (error) {
    throw error
  }
}

export const handleDeleteReimbursementDoc = async (id) => {
  try {
    const response = await apiClient.delete(`${ApiEndPoints.REIMBURSMENT_DOC}/${id}`)
    if (response?.data) {
      return response.data
    }
    throw new Error('not deleted.')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const updatedOnlyUploadedCategories = async (data) => {
  try {
    const response = await apiClient.patch(
      `${ApiEndPoints.REIMBURSMENT_DOC}/updateOnlyCategories`,
      data,
    )
    if (response?.data) {
      return response.data
    }
    throw new Error('not updated.')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
